import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TutorialCardComponent } from './tutorial-card.component';
import { VideoDialogModule } from 'src/app/components/video-dialog/video-dialog.module';
import { MatDialogModule } from '@angular/material/dialog';
import { PlayButtonModule } from '../../../components/play-button/play-button.module';



@NgModule({
  declarations: [
    TutorialCardComponent
  ],
  imports: [
    CommonModule,

    VideoDialogModule,

    MatDialogModule,
    PlayButtonModule
  ],
  exports: [
    TutorialCardComponent
  ]
})
export class TutorialCardModule { }
